import { render, staticRenderFns } from "./CreateCertificateModal.vue?vue&type=template&id=35ff4c46&scoped=true&"
import script from "./CreateCertificateModal.vue?vue&type=script&lang=js&"
export * from "./CreateCertificateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff4c46",
  null
  
)

export default component.exports